import React, { useEffect } from "react";
import styled from "styled-components";
import bangalorebg from "../../../../assets/images/bangalore/bg.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import VideoPopup from "../videoPopup";
import Header from "../Header/Header";
import CustomBanner from "../Banner/Banner";
import Screens from "../../../../assets/images/event/screen.png";
import Food from "../../../../assets/images/event/food.png";
import Seating from "../../../../assets/images/event/seating.png";
import Sound from "../../../../assets/images/event/sound.png";
import LocationShowCase from "../LocationShowCase/LocationShowCase";
import Footer from "../Footer/Footer";
import celebration from "../../../../assets/images/celebration.webp";
import { MdOutlineLocationOn, MdOutlineTouchApp } from "react-icons/md";
import { BsCalendarDate } from "react-icons/bs";
import { GiConfirmed } from "react-icons/gi";
import GalleryPage from "../../../Pages/CityLandingPage/Components/Gallery/Gallery";
import { useNavigate } from "react-router";
const Container = styled.div`
  font-family: "Arial", sans-serif;
  background: #fff;
  color: #000;
`;

const Section = styled.section`
  padding: 3rem 1rem;
  text-align: center;

  .background {
    background: url(${celebration}) center/cover no-repeat;
  }

  .desc {
    font-weight: 600;
    font-size: 1.2rem;
  }

  .desc.label {
    font-weight: 500;
  }
`;

const Banner = styled(Section)`
  background: url(${bangalorebg}) center/cover no-repeat;
  color: white;
  min-height: 84vh;
  position: relative;

  .bg-opaque {
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 11;
  }
`;

const Title = styled.h2`
  font-size: 4rem;
  font-weight: 900;
  line-height: 60px;
  position: absolute;
  top: 50%;
  left: 10%;
  font-family: "Inter", sans-serif;
  transform: translate(0, -50%);

  @media (max-width: 768px) {
    font-size: 2.8rem;
    text-align: center;
    line-height: 50px;
    left: 50%;
    top: 30%;
    transform: translate(-50%, 0%);
  }
`;

const SubTitle = styled.h2`
  font-size: 2rem;
  margin: 1rem 0;
  font-weight: 600;
`;

const FeatureGrid = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 2rem;
`;

const FeatureItem = styled.div`
  flex: 1 1 150px;
  margin: 1rem;
  text-align: center;

  p {
    font-weight: 600;
    margin-top: 10px;
  }
`;

const BookingButton = styled.button`
  background: #ffd700;
  color: black;
  padding: 1rem 2rem;
  font-size: 1rem;
  border: none;
  font-weight: bold;
  border-radius: 30px;
  cursor: pointer;
  margin-top: 2rem;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  width: 80%;
  margin: auto;
  margin-top: 2rem;

  @media (max-width: 769px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  padding: 1rem;
  border: 1px solid #ddd;
  padding: 20px;
  font-size: 1.2rem;
  border-radius: 10px;
  background-color: #f9f9f9;
`;

const Steps = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #6c27de;
`;

const Step = styled.div`
  margin: 1rem;
  padding: 1rem;
  border: 1px solid #ccc;
  border-radius: 10px;
  min-width: 220px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Icon = styled.div`
  font-size: 72px; /* Size of the icon */
  color: #000000; /* Black color for icons */
  margin-bottom: 10px; /* Space below the icon */
`;

export default function EventPage({ cardDetails }: any) {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    // Function to dynamically load a script
    const loadScript = (src = "", async = true, defer = false) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = async;
      script.defer = defer;
      script.charset = "UTF-8";
      document.body.appendChild(script);
    };

    // Load scripts dynamically
    loadScript("https://featurable.com/assets/bundle.js", true, true);
    loadScript("//www.instagram.com/embed.js", true);
    loadScript("https://cdn.lightwidget.com/widgets/lightwidget.js");

    return () => {
      // Clean up: remove scripts if needed
      document
        .querySelectorAll(
          "script[src*='featurable.com'], script[src*='instagram.com'], script[src*='lightwidget.com']"
        )
        .forEach((script) => script.remove());
    };
  }, []);
  return (
    <>
      <HelmetProvider>
        <Helmet></Helmet>
      </HelmetProvider>
      <Header />
      <VideoPopup />
      <CustomBanner />
      <Container>
        <Banner>
          <div className="bg-opaque">
            <Title>
              <em>
                {cardDetails?.heading1}
                <br />
                {cardDetails?.heading2}
              </em>
            </Title>
          </div>
        </Banner>

        <Section>
          <SubTitle>{cardDetails?.host?.heading} </SubTitle>
          <p className="desc">{cardDetails?.host?.description}</p>
          <FeatureGrid>
            <FeatureItem>
              <img src={Screens} alt="Private Screens" width="120" />
              <p>Private screens</p>
            </FeatureItem>
            <FeatureItem>
              <img src={Sound} alt="Surround Sound" width="120" />
              <p>Surround Sound</p>
            </FeatureItem>
            <FeatureItem>
              <img src={Seating} alt="Luxury Seating" width="120" />
              <p>Luxury seating</p>
            </FeatureItem>
            <FeatureItem>
              <img src={Food} alt="Food" width="120" />
              <p>Food</p>
            </FeatureItem>
          </FeatureGrid>
          <BookingButton onClick={() => navigate("/")}>
            Book Your Private Theater Now
          </BookingButton>
        </Section>

        <Section>
          <div className="background">
            <SubTitle>{cardDetails?.celebration_types?.heading}</SubTitle>
            {cardDetails?.celebration_types?.description && (
              <p className="desc label">
                {cardDetails?.celebration_types?.description}
              </p>
            )}
            <CardGrid>
              {cardDetails?.celebration_types?.items?.map((item: any) => (
                <Card>{item}</Card>
              ))}
            </CardGrid>
          </div>
        </Section>

        <Section>
          <SubTitle>Easy Booking Process</SubTitle>
          <Steps>
            <Step>
              <Icon>
                <MdOutlineTouchApp />
              </Icon>
              Select Your City
            </Step>
            <Step>
              <Icon>
                <MdOutlineLocationOn />
              </Icon>
              Choose Your Location
            </Step>
            <Step>
              <Icon>
                <BsCalendarDate />
              </Icon>
              Confirm Date & Time
            </Step>
            <Step>
              <Icon>
                <GiConfirmed />
              </Icon>
              Secure Your Slot
            </Step>
          </Steps>
          <BookingButton onClick={() => navigate("/")}>
            📩 Book Your Private Theater Now
          </BookingButton>
        </Section>

        <LocationShowCase heading="Top Private Theatres near you" />
      </Container>

      <GalleryPage />
      <Footer />
    </>
  );
}
